import { requests } from '.'
export const ConversationService = {
  getCountByCategory: (params: {
    locationId: string
    type: 'unread' | 'unassigned'
  }) =>
    requests().get('/conversations/count', {
      params,
    }),
}
